"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withMiddleware = undefined;

var _reactReduxFirebase = require("react-redux-firebase");

var _firebase = require("firebase");

var _firebase2 = _interopRequireDefault(_firebase);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = require("redux");

var _authLoaded = require("../selectors/auth-loaded");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://github.com/prescottprue/react-redux-firebase
var withFirebase = function withFirebase(opts) {
  if (opts.isOffline) return function (C) {
    return C;
  };
  return (0, _reactReduxFirebase.reactReduxFirebase)(_firebase2.default, {
    userProfile: "/users",
    enableLogging: !!opts.enableLogging
  });
};

var withThunk = function withThunk(opts) {
  return (0, _redux.applyMiddleware)(_reduxThunk2.default.withExtraArgument({ getFirebase: _reactReduxFirebase.getFirebase }));
};
var withMyAuth = function withMyAuth(opts) {
  if (opts.isOffline) return function (C) {
    return C;
  };
  return (0, _redux.applyMiddleware)(_authLoaded.middleware);
};

var withMiddleware = exports.withMiddleware = function withMiddleware(opts) {
  return [withFirebase(opts), withThunk(opts), withMyAuth(opts)];
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/redux/Store.js
// module id = 828
// module chunks = 0